import { render, staticRenderFns } from "./sidebar-proof.vue?vue&type=template&id=a3345f60&scoped=true&"
import script from "./sidebar-proof.vue?vue&type=script&lang=js&"
export * from "./sidebar-proof.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-proof.vue?vue&type=style&index=0&id=a3345f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3345f60",
  null
  
)

export default component.exports